import { Loader } from '@lifebit-ai/lds'
import { ValidationStatuses } from 'enums'
import React from 'react'

import type { Result } from 'services/results/types'

import * as styles from './ApprovalMethodLabel.styles'

interface ApprovalMethodLabelProps {
  validationStatus?: Result['validationStatus']
  isAutomaticApproved?: boolean
}

const ApprovalMethodLabel = ({ validationStatus, isAutomaticApproved }: ApprovalMethodLabelProps) => {
  if (
    validationStatus === ValidationStatuses.AutoCheckPassed ||
    validationStatus === ValidationStatuses.ReRequestAutoApproved
  ) {
    return (
      <styles.Container>
        <styles.ApprovedIcon />
        <span>Automated checks passed</span>
      </styles.Container>
    )
  }

  if (validationStatus === ValidationStatuses.AutoCheckFailed) {
    return (
      <styles.Container>
        <styles.InfoIcon />
        <span>Automated checks failed</span>
      </styles.Container>
    )
  }

  if (validationStatus === ValidationStatuses.NotChecked) {
    return (
      <styles.Container>
        <styles.WarningIcon />
        <span>Automated checks not checked</span>
      </styles.Container>
    )
  }

  if (validationStatus === ValidationStatuses.AutoCheckInProgress) {
    return (
      <styles.Container>
        <Loader size="small" />
        <span>Automated checks in progress</span>
      </styles.Container>
    )
  }

  if (isAutomaticApproved === false) {
    return <>Manually Approved</>
  }

  return <>-</>
}

export default ApprovalMethodLabel
